const Products = [
    {
        name: '槌子',
        start_price: 15,
        multiplier: 1.15,
        value: 1,
        icon: 'gavel',
        icon_var: 'faGavel',
        description: '多一个槌子，多敲一下。每秒功德自动+1。'
    },
    {
        name: '信徒',
        start_price: 200,
        multiplier: 1.18,
        value: 6,
        icon: 'person-praying',
        icon_var: 'faPersonPraying',
        description: '叫来一个虔诚的信徒帮你一起敲。每秒功德自动+6。'
    },
    {
        name: '金刚经',
        start_price: 2500,
        multiplier: 1.22,
        value: 18,
        icon: 'book-open',
        icon_var: 'faBookOpen',
        description: '念经可以加速功德。每秒功德自动+18。'
    },
    {
        name: '寺庙',
        start_price: 40000,
        multiplier: 1.26,
        value: 60,
        icon: 'place-of-worship',
        icon_var: 'faPlaceOfWorship',
        description: '寺庙里有成批的木鱼。每秒功德自动+60。'
    },
    {
        name: '基督',
        start_price: 150000,
        multiplier: 1.30,
        value: 180,
        icon: 'cross',
        icon_var: 'faCross',
        description: '扣1耶稣跟你一起笑。每秒功德自动+180。'
    },
    {
        name: '犹太',
        start_price: 600000,
        multiplier: 1.34,
        value: 550,
        icon: 'star-of-david',
        icon_var: 'faStarOfDavid',
        description: '扣1摩西跟你一起笑。每秒功德自动+550。'
    },
    {
        name: '清真',
        start_price: 2500000,
        multiplier: 1.38,
        value: 1600,
        icon: 'star-and-crescent',
        icon_var: 'faStarAndCrescent',
        description: '扣1真主跟你一起笑。每秒功德自动+1600。'
    },
    {
        name: '飞天意面神教',
        start_price: 12000000,
        multiplier: 1.42,
        value: 5000,
        icon: 'spaghetti-monster-flying',
        icon_var: 'faSpaghettiMonsterFlying',
        description: '你是要下地狱的，但是煮不在乎。每秒功德自动+5000。'
    },
    {
        name: '粒子对撞器',
        start_price: 50000000,
        multiplier: 1.5,
        value: 15000,
        icon: 'atom',
        icon_var: 'faAtom',
        description: '研究表明通过正负粒子撞击可以产生很多功德。每秒功德自动+15000。'
    }
];

export default Products;
